import React, { useMemo } from 'react';
import type { StyleProp, TextStyle } from 'react-native';

import { Markdown } from './markdown/markdown';
import { useColors, useFont } from '../hooks/lesson-player.context';
import type { ColorsType, FontsType } from '../interfaces';
import type { FontWeightStyle } from '../interfaces/fonts.type';
import markdownConverter from '../utils/markdown-converter';

export interface ThemedHTMLProps {
  type?: keyof ColorsType;
  fontType?: keyof FontsType;
  fontWeightStyle?: keyof FontWeightStyle;
  fontSize?: number;
  style?: StyleProp<TextStyle>;
  children?: React.ReactNode;
}

const ThemedHTML: React.FC<ThemedHTMLProps> = ({
  type = 'gray',
  fontType = 'primary',
  fontWeightStyle = 'regular',
  fontSize = 16,
  children,
  style,
}) => {
  const colors = useColors();
  const fonts = useFont();

  const color = colors[type] || colors.gray;
  const selectedFont =
    fonts?.[fontType]?.[fontWeightStyle] || fonts.primary.regular;

  const markdownText = useMemo(() => {
    try {
      return markdownConverter.turndown(children);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return children;
    }
  }, [children]);

  return (
    <Markdown
      style={[
        {
          color,
          fontSize,
          ...selectedFont,
        },
        style,
      ]}
    >
      {markdownText}
    </Markdown>
  );
};

export default ThemedHTML;
